import { render, staticRenderFns } from "./Branch-offices-documents.vue?vue&type=template&id=5ccfcc68"
import script from "./Branch-offices-documents.vue?vue&type=script&lang=js"
export * from "./Branch-offices-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports